'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LinkImage = require('./LinkImage');

var _LinkImage2 = _interopRequireDefault(_LinkImage);

var _VideoMedia = require('../../richMedia/components/video/VideoMedia');

var _VideoMedia2 = _interopRequireDefault(_VideoMedia);

var _RichMedia = require('../../richMedia/components/RichMedia');

var _RichMedia2 = _interopRequireDefault(_RichMedia);

var _MapMedia = require('../../richMedia/components/map/MapMedia');

var _MapMedia2 = _interopRequireDefault(_MapMedia);

var _richMediaConstants = require('../../../../common/links/richMediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkMedia = function LinkMedia(props) {
    var element = props.element;


    var mediaType = element.getIn(['content', 'mediaType']);

    switch (mediaType) {
        case _richMediaConstants.MEDIA_TYPES.VIDEO:
            return _react2.default.createElement(_VideoMedia2.default, props);
        case _richMediaConstants.MEDIA_TYPES.MAP:
            return _react2.default.createElement(_MapMedia2.default, props);
        case _richMediaConstants.MEDIA_TYPES.RICH:
            return _react2.default.createElement(_RichMedia2.default, props);
        default:
            return _react2.default.createElement(_LinkImage2.default, props);
    }
};

// Constants


// Components
// Lib


LinkMedia.propTypes = {
    element: _propTypes2.default.object.isRequired
};

exports.default = LinkMedia;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/link/richMedia/LinkMedia.js
// module id = 2005
// module chunks = 0